import { blobticService } from '../../Commun/services/blobticService';

export interface Driver {
    id: number;
    uid: string;
    firstName: string;
    lastName: string;
    licenseNumber: string;
    licenseType: string;
    licenseExpiry: Date;
    experienceYears: number;
    status: string;
    hireDate: Date;
    phone?: string;
    telegramChatId?: string;
    function?: string;
    affectationId?: number;
    vehicleId?: number;
    assignedDate?: Date;
    isTempReplacement?: boolean;
    tempVehicleId?: number;
    vehicleRegistration?: string;
    departmentName?: string;
    tempVehicleRegistration?: string;
    lastUpdate?: Date;
    userId?: number;
}

interface DriverDto {
    DRV_IDF: number;
    DRV_UIDF: string;
    DRV_FIRSTNAME?: string;
    DRV_LASTNAME?: string;
    DRV_LICENSE_NUMBER: string;
    DRV_LICENSE_TYPE: string;
    DRV_LICENSE_EXPIRY: string;
    DRV_EXPERIENCE_YEARS: number;
    DRV_STATUS: string;
    DRV_HIRE_DATE: string;
    DRV_PHONE?: string;
    DRV_TELEGRAM_CHAT_ID?: string;
    DRV_FUNCTION?: string;
    AFF_IDF?: number;
    VEH_IDF?: number;
    DRV_ASSIGNED_DATE?: string;
    DRV_IS_TEMP_REPLACEMENT?: boolean;
    DRV_TEMP_VEHICLE_ID?: number;
    VEH_REGISTRATION?: string;
    DRV_DEPARTMENT?: string;
    TEMP_VEH_REGISTRATION?: string;
    LAST_UPDT?: string;
    USER_IDF?: number;
}

const mapDtoToModel = (dto: DriverDto): Driver => ({
    id: dto.DRV_IDF,
    uid: dto.DRV_UIDF,
    firstName: dto.DRV_FIRSTNAME || '',
    lastName: dto.DRV_LASTNAME || '',
    licenseNumber: dto.DRV_LICENSE_NUMBER,
    licenseType: dto.DRV_LICENSE_TYPE,
    licenseExpiry: new Date(dto.DRV_LICENSE_EXPIRY),
    experienceYears: dto.DRV_EXPERIENCE_YEARS,
    status: dto.DRV_STATUS,
    hireDate: new Date(dto.DRV_HIRE_DATE),
    phone: dto.DRV_PHONE,
    telegramChatId: dto.DRV_TELEGRAM_CHAT_ID,
    function: dto.DRV_FUNCTION,
    affectationId: dto.AFF_IDF,
    vehicleId: dto.VEH_IDF,
    assignedDate: dto.DRV_ASSIGNED_DATE ? new Date(dto.DRV_ASSIGNED_DATE) : undefined,
    isTempReplacement: dto.DRV_IS_TEMP_REPLACEMENT,
    tempVehicleId: dto.DRV_TEMP_VEHICLE_ID,
    vehicleRegistration: dto.VEH_REGISTRATION,
    departmentName: dto.DRV_DEPARTMENT,
    tempVehicleRegistration: dto.TEMP_VEH_REGISTRATION,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
    userId: dto.USER_IDF
});

export const driversApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_driver,Select' }
        });
        if (response.success && Array.isArray(response.data)) {
            return { data: response.data.map((item: any) => mapDtoToModel(item)), success: true };
        }
        return { data: [], success: false, message: response.message };
    },

    create: async (data: Partial<Driver>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_driver,Insert',
            DRV_FIRSTNAME: data.firstName,
            DRV_LASTNAME: data.lastName,
            DRV_LICENSE_NUMBER: data.licenseNumber,
            DRV_LICENSE_TYPE: data.licenseType,
            DRV_LICENSE_EXPIRY: data.licenseExpiry?.toISOString(),
            DRV_EXPERIENCE_YEARS: data.experienceYears || 0,
            DRV_STATUS: data.status || 'active',
            DRV_HIRE_DATE: data.hireDate?.toISOString() || new Date().toISOString(),
            DRV_PHONE: data.phone,
            DRV_TELEGRAM_CHAT_ID: data.telegramChatId,
            DRV_FUNCTION: data.function,
            AFF_IDF: data.affectationId,
            VEH_IDF: data.vehicleId,
            DRV_ASSIGNED_DATE: data.assignedDate?.toISOString(),
            DRV_IS_TEMP_REPLACEMENT: data.isTempReplacement || false,
            DRV_TEMP_VEHICLE_ID: data.tempVehicleId
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    update: async (id: number, data: Partial<Driver>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_driver,Update',
            DRV_IDF: id,
            DRV_FIRSTNAME: data.firstName,
            DRV_LASTNAME: data.lastName,
            DRV_LICENSE_NUMBER: data.licenseNumber,
            DRV_LICENSE_TYPE: data.licenseType,
            DRV_LICENSE_EXPIRY: data.licenseExpiry?.toISOString(),
            DRV_EXPERIENCE_YEARS: data.experienceYears,
            DRV_STATUS: data.status,
            DRV_HIRE_DATE: data.hireDate?.toISOString(),
            DRV_PHONE: data.phone,
            DRV_TELEGRAM_CHAT_ID: data.telegramChatId,
            DRV_FUNCTION: data.function,
            AFF_IDF: data.affectationId,
            VEH_IDF: data.vehicleId,
            DRV_ASSIGNED_DATE: data.assignedDate?.toISOString(),
            DRV_IS_TEMP_REPLACEMENT: data.isTempReplacement,
            DRV_TEMP_VEHICLE_ID: data.tempVehicleId
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    delete: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_driver,Delete', DRV_IDF: id }
        });
        return response;
    }
};
